import { Component, Input, OnChanges, signal, SimpleChanges, WritableSignal, inject } from '@angular/core';
import { EmptyIndicatorPipe } from '../../pipes/empty-indicator.pipe';
import { Clipboard } from '@angular/cdk/clipboard';
import { ToastService } from '../../../_services/toast-service/toast.service';
import { NgClass } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-info-block',
  imports: [EmptyIndicatorPipe, NgClass, NgbTooltip],
  templateUrl: './info-block.component.html',
})
export class InfoBlockComponent implements OnChanges {
  readonly clipboard = inject(Clipboard);
  readonly toastService = inject(ToastService);

  @Input() label: unknown;
  @Input() value: unknown;
  @Input() placeholder?: string;
  @Input() showCopyClipboard?: boolean = false;
  @Input() showButton?: boolean = false;
  @Input() showLineBreaks?: boolean = false;
  @Input() bgClass?: string;
  @Input() tooltipText?: string;
  @Input() tooltipIcon?: string = 'iconoir-info-circle';
  @Input() tooltipClass: string = 'text-info';
  @Input() tooltipDisplay: boolean = false;

  protected showPlaceholder: WritableSignal<boolean> = signal(false);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.showPlaceholder.set(!!this.placeholder?.length && !this.value);
    }
  }

  copyTextToClipboard(text: string): void {
    this.clipboard.copy(text);
    this.toastService.show('Copied to clipboard', 'iconoir-check');
  }
}
